import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from "react-router-dom";
import DreamsLogo from '../../images/logo512.png';
import bgImage from '../../images/bgImage.png';
import { BiExitFullscreen, BiFullscreen } from 'react-icons/bi';

export default function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const [error, setError] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const userData = localStorage.getItem('user');
    const user = JSON.parse(userData);

    

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            navigate("/crm/lead_dashboard");
        }
    }, [navigate]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        try {
            const response = await axios.post('public/api/login', {
                email: email,
                password: password
            });
        
            if (response.data.success) {
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('role_id', response.data.user.role_id);
                localStorage.setItem('user', JSON.stringify(response.data.user));
                localStorage.setItem('user_id', JSON.stringify(response.data.user.id));
                localStorage.setItem('user_name', JSON.stringify(response.data.user.name));

                navigate(0);

            } else {
                setError(response.data);
                setErrorMessage(response.data.message);
                console.error('Login failed');
            }

        } catch (error) {
            console.error('Error during login:', error);
        } finally {
            setLoading(false);
        }
    };


    const toggleFullScreen = () => {
        const doc = window.document;
        const docEl = doc.documentElement;

        const requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
        const exitFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

        if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
            requestFullScreen.call(docEl);
        } else {
            exitFullScreen.call(doc);
        }
    };


    return (
        <>
            <div className="min-h-screen flex items-center justify-center" >
                <div className="max-w-md w-full space-y-8 shadow-lg overflow-hidden p-7 bg-white">
                    <div>
                        <img className="mx-auto h-42 w-full" src={DreamsLogo} alt="Workflow" />
                        <h2 className="mt-0 text-center text-3xl font-extrabold text-gray-900">Sign in to your account</h2>
                    </div>

                    <button
                        type="button"
                        className="absolute top-0 right-0 m-4 p-2 text-gray-400 hover:text-gray-500 bg-gray-100 rounded"
                        onClick={toggleFullScreen}
                    >
                        {document.fullscreenElement ? (
                            <BiExitFullscreen className="text-gray-600 h-6 w-6" aria-hidden="true" />
                        ) : (
                            <BiFullscreen className="text-gray-600 h-6 w-6" aria-hidden="true" />
                        )}
                    </button>



                    <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
                        <input type="hidden" name="remember" value="true" />
                        <div className="rounded-md shadow-sm -space-y-px">
                            <div>
                                <label htmlFor="email-address" className="sr-only">Email address</label>
                                <input
                                    id="email-address"
                                    name="email"
                                    type="email"
                                    autoComplete="email"
                                    required
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="appearance-none rounded-none relative block w-full px-3 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                                    placeholder="Email address"
                                />
                            </div>
                            <div>
                                <label htmlFor="password" className="sr-only">Password</label>
                                <input
                                    id="password"
                                    name="password"
                                    type="password"
                                    autoComplete="current-password"
                                    required
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="appearance-none rounded-none relative block w-full px-3 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                                    placeholder="Password"
                                />
                            </div>
                        </div>
                        {errorMessage && (
                            <p className="mt-2 text-sm text-red-600" id="email-error">{errorMessage}</p>
                        )}

                        <div className="flex items-center justify-end">
                            {/* <div className="flex items-center">
                                <input id="remember-me" name="remember-me" type="checkbox" className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded" />
                                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900">Remember me</label>
                            </div> */}

                            {/* <div className="text-sm">
                                <Link to="/forgot/password" className="font-medium text-indigo-600 hover:text-indigo-500">Forgot your password?</Link>
                            </div> */}
                        </div>

                        <div>
                            <button
                                type="submit"
                                disabled={loading}
                                className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            >
                                {loading ? (
                                    <svg
                                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.373A8 8 0 0112 4v4a4 4 0 00-4 4h4a4 4 0 004-4h4a8 8 0 01-8 8v-4a4 4 0 00-4-4z"
                                        ></path>
                                    </svg>
                                ) : null}
                                {!loading && "Sign in"}
                            </button>

                        </div>
                    </form>
                    {/* <p className="mt-2 text-center text-sm text-gray-600">Not registered yet? <Link to="/signup" className="font-medium text-indigo-600 hover:text-indigo-500">Create an account</Link></p> */}
                </div>
            </div>
        </>
    );
}
